import { create } from 'zustand';
import {
  addNewSupervisorMessageAction,
  getSecurityCodalReportDataAction,
  getSupervisorMessageData,
} from './action';
import {
  CodalReportDataType,
  SupervisorMessageType,
} from 'typings/security.type';

type SecurityStoreType = {
  codalReportData: CodalReportDataType[];
  codalReportLoading: boolean;
  codalReportError: boolean;
  codalPageNumber: number;
  codalDataCount: number;
  codalId: string;
  getSecurityCodalReportDataAction: (id: string, page: number) => Promise<void>;
  reset: () => void;
  supervisorMessageData: SupervisorMessageType[];
  supervisorMessageLoading: boolean;
  supervisorMessageError: boolean;
  supervisorMessagePageNumber: number;
  supervisorMessageDataCount: number;
  supervisorMessageId: string;
  getSupervisorMessageData: (id: string, page: number) => Promise<void>;
  addNewSupervisorMessageAction: (
    message: SupervisorMessageType,
  ) => Promise<void>;
};

const initialState = {
  codalReportData: null,
  codalReportLoading: false,
  codalReportError: false,
  codalPageNumber: 1,
  codalDataCount: 0,
  codalId: '',
  supervisorMessageData: null,
  supervisorMessageLoading: false,
  supervisorMessageError: false,
  supervisorMessagePageNumber: 1,
  supervisorMessageDataCount: 0,
  supervisorMessageId: '',
};

const useSecurityStore = create<SecurityStoreType>((set) => ({
  ...initialState,
  reset: (): void => set(initialState),
  getSecurityCodalReportDataAction: async (
    id: string,
    page: number,
  ): Promise<void> => getSecurityCodalReportDataAction(set, id, page),
  getSupervisorMessageData: async (id: string, page: number): Promise<void> =>
    getSupervisorMessageData(set, id, page),
  addNewSupervisorMessageAction: async (
    message: SupervisorMessageType,
  ): Promise<void> => addNewSupervisorMessageAction(set, message),
}));

export default useSecurityStore;
